import { render, staticRenderFns } from "./DashboardTabs.vue?vue&type=template&id=1a0bb6e2&scoped=true&"
import script from "./DashboardTabs.vue?vue&type=script&lang=js&"
export * from "./DashboardTabs.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTabs.vue?vue&type=style&index=0&id=1a0bb6e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0bb6e2",
  null
  
)

export default component.exports